import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "list"]

  connect() {
    this.element.querySelectorAll('a[href^="#"]').forEach(link => {
      link.addEventListener("click", this.smoothScrollToAnchor.bind(this))
    })
  }

  search(event) {
    if (event) event.preventDefault()
    const term = this.inputTarget.value.trim()
    if (!term) return

    const slug = this.toSlug(term)
    const byId = document.getElementById(slug)
    if (byId) {
      byId.scrollIntoView({ behavior: "smooth", block: "start" })
      return
    }

    const headings = this.listTarget.querySelectorAll("h3[id]")
    const lower = term.toLowerCase()
    for (const h of headings) {
      if (h.textContent.toLowerCase().includes(lower)) {
        h.scrollIntoView({ behavior: "smooth", block: "start" })
        return
      }
    }
  }

  smoothScrollToAnchor(event) {
    const href = event.currentTarget.getAttribute("href")
    if (href === "#" || !href.startsWith("#")) return
    const id = href.slice(1)
    const el = document.getElementById(id)
    if (el) {
      event.preventDefault()
      el.scrollIntoView({ behavior: "smooth", block: "start" })
    }
  }

  toSlug(text) {
    return text
      .toLowerCase()
      .replace(/[^\w\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-")
      .trim()
  }
}
